/**
 * Dependencies
 */
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import initBaseStyles from '@nerdwallet/base-styles/init';
import { initBrowserEvents } from '@nerdwallet/analytics';
import arrayFrom from 'array.from';

import routeDefinitions from './routes/index';

if (!Array.from) arrayFrom.shim();

initBaseStyles();
initBrowserEvents();
if (typeof __SENTRY_VERSION__ !== 'undefined') {
  // Require this here so we don't see a handful of console warnings related to finding sourcemaps
  // eslint-disable-next-line global-require
  require('@nerdwallet/sentry').initSentryBrowser({
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    version: __SENTRY_VERSION__,
  });
}

// Webpack lets us us embed styles and assets within the code.
require('@nerdwallet/base-styles/reset.css');
require('@nerdwallet/base-styles/base.css');
require('./styles/main.less');

const Main = () => <Router>{routeDefinitions}</Router>;

export default Main;
